import axios from 'axios';
import baseURL, { endPoints } from '../Config';

const handleRefreshToken = async () => {
    try {
        const loginData = JSON.parse(localStorage.getItem('user'));
        const refreshToken = loginData?.data?.refreshToken;

        const response = await axios({
            method: 'post',
            url: `${baseURL}${endPoints.refreshToken}`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: {
                refreshToken: refreshToken
            }
        });

        const newTokens = response?.data?.data;

        if (loginData?.data && newTokens) {
            loginData.data.token = newTokens.token;
            loginData.data.refreshToken = newTokens.refreshToken;

            localStorage.setItem('user', JSON.stringify(loginData));
        }

        return newTokens.token;
    } catch (error) {
        return null;
    }
};

export default handleRefreshToken;
